import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "../../i18n";

export default function Footer() {
  const { t } = useTranslation();
  const tf = (key, fallback) => (t(key) === key ? fallback : t(key));
  const year = new Date().getFullYear();
  const links = [
    { to: "/products", label: tf("marketing.nav.features", "Funktionen") },
    { to: "/pricing", label: tf("marketing.nav.pricing", "Preise") },
    { to: "/documentation", label: tf("marketing.nav.help", "Hilfe-Center") },
    { to: "/privacy", label: t("layout.footer.privacy") },
    { to: "/terms", label: t("layout.footer.terms") },
    { to: "/impressum", label: t("layout.footer.imprint") },
  ];

  return (
    <footer className="bg-surface-nav border-t border-outline-variant">
      <div className="max-w-[1440px] mx-auto px-6 md:px-14 py-8 flex flex-wrap items-center gap-x-6 gap-y-3 text-[12.5px] text-on-surface-faint">
        {/* Brand */}
        <div className="flex items-center gap-2 text-on-surface-muted">
          <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
            <circle
              cx="12"
              cy="12"
              r="10"
              fill="none"
              stroke="rgb(var(--primary))"
              strokeWidth="2"
            />
            <circle cx="12" cy="12" r="4" fill="rgb(var(--primary))" />
          </svg>
          <span className="font-medium">Customy</span>
        </div>

        {/* Links */}
        {links.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className="hover:text-on-surface transition-colors duration-150"
          >
            {link.label}
          </Link>
        ))}

        <span className="ml-auto">{t("layout.footer.copyright", { year })}</span>
      </div>
    </footer>
  );
}
